import React, { useEffect, useState } from "react";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { useDispatch, useSelector } from "react-redux";
import {
  Chip,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import NewBazshoDialog from "./components/NewBazshoDialog/NewBazshoDialog";
import { read } from "Helpers/LocalStorage";
import { getAllBazsho, setNameForSearchBazshoYaragh } from "Stores/actions";
import { SELECT_BAZSHO } from "Stores/actionTypes";
import DeleteBazsho from "./components/DeleteBazsho";
import Translator from "Languages/Utility/Translator";
import {ReactSVG} from "react-svg";
import checkBoxCheckIcon from "Assets/svg/icon/checkBoxCheckIcon.svg";
import checkedBoxIcon from "Assets/svg/icon/checkedBoxIcon.svg";
import { useTranslation } from 'react-i18next';
import Input from "Components/Input/Input";
import * as Icons from 'react-bootstrap-icons'
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import EditBazsho from "./components/EditBazsho";
import { useTheme } from '@material-ui/core/styles';

function Bazsho() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { bazshoList, selectedBazsho, selectedBrandYaragh, bazshoYaraghSearch} = useSelector(
    (state) => ({
      bazshoList: state.yaragh.bazshoList,
      selectedBazsho: state.yaragh.selectedBazsho,
      selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
      bazshoYaraghSearch: state.yaragh.bazshoYaraghSearch,
    })
  );
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(false);

  const handleChange = async (value) => {
    dispatch({
      type: SELECT_BAZSHO,
      selectedBazsho: value,
    });
  };

  const setValue = (name, value) => {
    dispatch(setNameForSearchBazshoYaragh(value));
  };

  const onSearch = async (e) => {
    e.preventDefault();
    await onGetAllBazsho();
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    await onGetAllBazsho(true);
  }

  useEffect(() => {
    (async () => {
      await onGetAllBazsho();
    })();
  }, [selectedBrandYaragh]);

  const onGetAllBazsho = async (clear = false, selectedIndex = -1) => {
    try {
      if(selectedBrandYaragh ) {
        setLoading(true);
        let dataSearch = null;
        if(!clear && bazshoYaraghSearch && bazshoYaraghSearch !== "") dataSearch = { Name: bazshoYaraghSearch } 
        if(clear) dispatch(setNameForSearchBazshoYaragh(""));
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdBrandFitting: selectedBrandYaragh.Id,
          ...dataSearch
        };
        await dispatch(getAllBazsho(params, selectedIndex));
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="side-box">
        <div>
          <MuiIconButton
            title={<Translator id={"searchPop"} />}
            icon={<Icons.Search size={17}/>}
            onClick={() => setSearch(!search)}
            className={`fix-size ${search ? "standby" : ''}`}
            disabled={!selectedBrandYaragh}
          />
          <Translator id={"pop"} />
        </div>
        <div>
          {
            bazshoList && selectedBrandYaragh &&
            <>
              <NewBazshoDialog selectedBrandYaragh={selectedBrandYaragh} reGetOnBack={onGetAllBazsho} />
              <EditBazsho reGetOnBack={onGetAllBazsho}/>
              <DeleteBazsho reGetOnBack={onGetAllBazsho} />
            </>
          }
        </div>
      </div>
      <div className={`search-box-sidebox ${search ? 'show-mode' : 'hide-mode' }`}>
        <Input
          key={"pop-search-box"}
          setValue={setValue.bind(this)}
          name="search"
          value={bazshoYaraghSearch}
          placeholder={t('searchPop')}
          type="search"
          onSearch={onSearch}
          onClearSearch={onClearSearch}
        />
      </div>
      {bazshoList && selectedBazsho && (
        <FormControl component="fieldset" className="radioGroup sideBoxLg">
          <RadioGroup>
            {bazshoList.map((item) => {
              return (
                <div className="d-flex justify-content-between" key={item.Id}>
                  <FormControlLabel
                    value={`${item.Id}`}
                    key={item.Id}
                    className={ direction === 'rtl' ? "text-right" : "text-left" }
                    control={
                      <Radio
                        // size="small"
                        checked={selectedBazsho.Id === item.Id}
                        onChange={() => handleChange(item)}
                        className="mx-2"
                        // checkedIcon={<ReactSVG src={checkBoxCheckIcon} />}
                        // icon={<ReactSVG src={checkedBoxIcon} />}
                      />
                    }
                    label={item.Name}
                  />
                  <Chip
                    className={
                      item.WinDoor === 1
                        ? "window my-auto ml-1"
                        : "door my-auto ml-1"
                    }
                    label={item.NameWinDoor}
                  />
                </div>
              );
            })}
          </RadioGroup>
        </FormControl>
      )}
    </>
  );
}

export default Bazsho;
